/* components/LoadMore */

import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import Marquee from '@mollahdev/marquee';

@Component
export class MarqueeText extends ThemeComponent {
    @Prop targetItem!: string;
    @Prop scrollDirection!: string;
    @Prop scrollDuration!: string;

    init() {
        new Marquee( this.targetItem, {
            direction: this.scrollDirection,
            duration: this.scrollDuration
        });
    }
}
